export const PENDING_SSO_TARGET_STORAGE_KEY = 'copilot-task-composer:pending-sso-target'

export function hasPendingSsoChatTarget(): boolean {
  try {
    return sessionStorage.getItem(PENDING_SSO_TARGET_STORAGE_KEY) === 'chat'
  } catch {
    return false
  }
}

export function setPendingSsoChatTarget(): void {
  try {
    sessionStorage.setItem(PENDING_SSO_TARGET_STORAGE_KEY, 'chat')
  } catch {
    return
  }
}

export function clearPendingSsoChatTarget(): void {
  try {
    sessionStorage.removeItem(PENDING_SSO_TARGET_STORAGE_KEY)
  } catch {
    return
  }
}
